import { useEffect, useState } from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import Select from "react-select";
import { ReactSearchAutocomplete } from "react-search-autocomplete";
import { kayaCRUD } from "../../../../actions/kaya";

export const Registration = (props) => {
  const { data, next, back, step3, setStep3, step2, setStep2, schema } = props;

  const [kaya, setKaya] = useState([]);
  const [value, setValue] = useState("");

  useEffect(() => {
    setTimeout(() => {
      kayaCRUD
        .loadKayaData(10, 0, value, "")
        .then((resp) => {
          setKaya(resp.data.results);
        })
        .finally(() => {});
      kayaCRUD.loadKayaDetails(data.kaya_id);
    }, 500);
  }, [value]);

  const handleSubmite = (values) => {
    next(values, false);
    setStep3(!step3);
  };

  const handlePrev = (values) => {
    back(values);
    setStep2(!step2);
  };

  const handleOnSearch = (string) => {
    setValue(string);
  };

  const formatResult = (kaya) => {
    return (
      <>
        <span style={{ display: "block", textAlign: "left" }}>
          {kaya.head_phone_number}
        </span>
      </>
    );
  };

  return (
    <>
      <Formik
        initialValues={data}
        onSubmit={handleSubmite}
        validationSchema={schema}
        enableReinitialize={true}
      >
        {({ setFieldValue, values }) => (
          <Form>
            <div
              className={
                step3
                  ? "tab-pane fade"
                  : !step2
                  ? "tab-pane fade"
                  : "tab-pane fade show active"
              }
              id="step-register-info"
              role="tabpanel"
              aria-labelledby="step-register-tab"
            >
              <div>
                <div className="row">
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="reg_date" className="form-label">
                        Registered Date <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="date"
                        id="reg_date"
                        className="form-control bg-light"
                        name="reg_date"
                        readOnly
                      />
                      <small className="text-muted">Auto-filled with today's date</small>
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="reg_date" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="reg_no" className="form-label">
                        Registration Number{" "}
                        <span className="text-danger">*</span>
                      </label>
                      <Field
                        type="text"
                        id="reg_no"
                        className="form-control bg-light"
                        placeholder="Will be auto-generated"
                        name="reg_no"
                        readOnly
                      />
                      <small className="text-muted">Auto-generated when you select Residential Status in the next step</small>
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="reg_no" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-12">
                    <div
                      className="mb-3"
                      style={{ display: data.kaya_id >= 1 && "none" }}
                    >
                      <label htmlFor="marital_status" className="form-label">
                        House Hold <span className="text-danger">*</span>
                      </label>
                      <ReactSearchAutocomplete
                        items={kaya}
                        onSearch={handleOnSearch}
                        onSelect={(e) => setFieldValue("kaya_id", e.id)}
                        autoFocus
                        showItemsOnFocus={true}
                        styling={{
                          borderRadius: "4px",
                          height: "36px",
                          fontFamily: "Verdana, Arial, sans-serif",
                          fontSize: "0.8125rem",
                          fontWeight: 400,
                          zIndex: 100,
                        }}
                        inputDebounce={500}
                        placeholder={"Select House Hold"}
                        showIcon={false}
                        formatResult={formatResult}
                        fuseOptions={{ keys: ["head_phone_number", "code"] }}
                        resultStringKeyName={"head_phone_number"}
                        name="kaya_id"
                      />
                      <div
                        className="fw-light h6 mt-1"
                        style={{ fontSize: "15px" }}
                      >
                        <span role="alert" className="text-danger">
                          <ErrorMessage name="kaya_id" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className="col-md-12 col-sm-12">
                    <div className="mb-3">
                      <label htmlFor="detail_info" className="form-label">
                        Descriptions{" "}
                      </label>
                      <Field
                        as="textarea"
                        rows={6}
                        type="text"
                        id="detail_info"
                        className="form-control"
                        placeholder="Detail"
                        name="detail_info"
                      ></Field>
                    </div>
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-start gap-3 mt-4">
                <button
                  type="button"
                  className="btn btn-light btn-label previestab"
                  onClick={handlePrev}
                >
                  <i className="ri-arrow-left-line label-icon align-middle fs-16 me-2"></i>{" "}
                  Back
                </button>
                <button
                  type="submit"
                  className="btn btn-success btn-label right ms-auto nexttab nexttab"
                >
                  <i className="ri-arrow-right-line label-icon align-middle fs-16 ms-2"></i>
                  Next
                </button>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </>
  );
};
